<template>
  <div v-if="true" class="flex flex-col text-sm font-mono">
    <div v-if="declaration" class="xml-declaration">&lt;?xml 
      <span v-if="declaration.version" class="xml-attr">version="<span class="xml-attr-value">{{ declaration.version }}</span>" </span>
      <span v-if="declaration.encoding" class="xml-attr">encoding="<span class="xml-attr-value">{{ declaration.encoding }}</span>" </span>
      <span v-if="declaration.standalone" class="xml-attr">standalone="<span class="xml-attr-value">{{ declaration.standalone }}</span>" </span>?&gt;
    </div>
    <xml-tag :xmlFragment="document"/>
  </div>
</template>
<script>
import XMLTag from '@/components/XMLTag.vue'
export default {
  name: 'xml-doc',
  components: {
    'xml-tag': XMLTag
  },
  props: {
    xmlString: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
    }
  },
  computed: {
    declaration () {
      const declaration = { version: null, encoding: null, standalone: null }
      const declarationMatch = this.xmlString.match(/^<\?xml\s+(.*?)\?>/i)
      if (!declarationMatch) {
        return null
      }
      const attrs = declarationMatch[1]
      if (!attrs) {
        declaration.version = '1.0'
      } else {
        declaration.version = attrs.match(/\bversion="(.*?)"/i)?.[1] ?? '1.0'
        declaration.encoding = attrs.match(/\bencoding="(.*?)"/i)?.[1] ?? null
        declaration.standalone = attrs.match(/\bstandalone="(.*?)"/i)?.[1] ?? null
      }

      return declaration
    },
    document () {
      const parser = new DOMParser()
      const doc = parser.parseFromString(this.xmlString, 'text/xml')
      return doc.documentElement
    },
    strDoc () {
      return this.serializeNode(this.document)
    }
  },
  methods: {
    serializeNode (node) {
      return new XMLSerializer().serializeToString(node)
    }
  }
}
</script>
<style lang="scss" scoped>
.xml-declaration {
  display: block;
  color: var(--primary-900);
}
.xml-attr {
  /* display: flex; */
  color: var(--primary-600);
  /* padding: 0px 0.3rem; */
}
.xml-attr-value {
  color: var(--darkblue-500);
  width: 100%;
}

.dark {
  .xml-declaration {
    color: var(--darkblue-100);
  }
  .xml-attr {
    color: var(--primary-200);
  }
  .xml-attr-value {
    color: var(--darkblue-300);
  }
}
</style>
